export default __webpack_public_path__ + "static/media/ar-off.27305b33.png";